import React from 'react';
import { CheckIcon, ChevronDownIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { TOMOS } from '../../data/content';
export function TomosList() {
  return <section className="w-full bg-cream-deep px-5 py-14 sm:py-20" data-id="element-246" data-mp="1vd6z8nvu5mfe">
      <div className="mx-auto max-w-3xl" data-id="element-247" data-mp="20bi9gzq1lyy5">
        <Reveal className="text-center" data-id="element-248" data-mp="20agmpxznzo0l">
          <SectionBadge data-id="element-249" data-mp="13kpnxmkcbeoz">Todo organizado en un solo lugar</SectionBadge>
          <h2 className="mt-5 font-display text-3xl leading-tight text-cocoa sm:text-5xl" data-id="element-250" data-mp="13imqwikrslar">
            <span className="italic text-terra" data-id="element-251" data-mp="17mkoupyczq28">6 tomos</span> para acompañarte desde cero
          </h2>
        </Reveal>

        <div className="mt-10 space-y-3" data-id="element-252" data-mp="1cjkw346y2yux">
          {TOMOS.map((tomo, index) => <Reveal key={tomo.n} delay={Math.min(index, 3) * 50} data-id="element-253" data-mp="1hdp841v2hx2v" data-mpi={index}>
              <details open={index === 0} className="group overflow-hidden rounded-2xl bg-cream-card" data-id="element-254" data-mp="jxiaps2xofch">
                <summary className="flex cursor-pointer list-none items-center gap-3 p-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-terra sm:p-6 [&::-webkit-details-marker]:hidden" data-id="element-255" data-mp="ourwmxr468vk">
                  <span className="flex h-10 w-10 flex-shrink-0 sm:h-11 sm:w-11 items-center justify-center rounded-full font-display text-xl text-cream" style={{
                backgroundColor: tomo.color
              }} data-id="element-256" data-mp="2ln79b1ozg3z2">
                    {tomo.n}
                  </span>
                  <span className="flex-1" data-id="element-257" data-mp="26yu91siv3yyr">
                    <span className="block text-[10px] font-extrabold uppercase tracking-[0.18em] text-terra" data-id="element-258" data-mp="26veuqrx0itye">
                      Tomo {tomo.n}
                    </span>
                    <span className="mt-0.5 block font-display text-xl leading-snug text-cocoa sm:text-2xl" data-id="element-259" data-mp="1xxmn89xj8qlk">
                      {tomo.title}
                    </span>
                    <span className="mt-1 block text-sm leading-snug text-cocoa-soft" data-id="element-260" data-mp="3sbdtczgnksc9">{tomo.summary}</span>
                  </span>
                  <ChevronDownIcon className="h-4 w-4 flex-shrink-0 text-cocoa-dim transition-transform duration-200 ease-out group-open:rotate-180" aria-hidden="true" data-id="element-261" data-mp="3ncsub3d50epe" />
                </summary>
                <div className="px-4 pb-5 sm:pb-6 sm:pl-[84px] sm:pr-6" data-id="element-262" data-mp="f3ji4ozfrndi">
                  {tomo.detail && <p className="text-sm leading-relaxed text-cocoa" data-id="element-263" data-mp="1bvbh17yhr3x">{tomo.detail}</p>}
                  {tomo.checks && <ul className="flex flex-wrap gap-2" data-id="element-264" data-mp="6a6ht1z1ljhe">
                      {tomo.checks.map(check => <li key={check} className="inline-flex items-center gap-1.5 rounded-full bg-olive-soft px-3 py-1.5 text-xs font-semibold text-olive" data-id="element-265" data-mp="u0amlcnyvp9z">
                          <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-266" data-mp="k11ukpcnwkq9" />
                          {check}
                        </li>)}
                    </ul>}
                </div>
              </details>
            </Reveal>)}
        </div>
      </div>
    </section>;
}